import { AppThunk } from '@/store'
import { createAction } from '@/store/actions'

import {
  AUTHENTICATION_FAILURE,
  AUTHENTICATION_SIGNOUT,
  AUTHENTICATION_SUCCESS,
  EXPIRED_SESSION_FAILURE
} from './actionTypes'

export function authenticationFailure(): AppThunk {
  return dispatch => new Promise(resolve => resolve(dispatch(createAction(AUTHENTICATION_FAILURE))))
}

export function authenticationSignout(): AppThunk {
  return dispatch => new Promise(resolve => resolve(dispatch(createAction(AUTHENTICATION_SIGNOUT))))
}

export function authenticationSuccess(session: unknown): AppThunk {
  return dispatch => new Promise(resolve => resolve(dispatch(createAction(AUTHENTICATION_SUCCESS, { session }))))
}

export function expiredSessionFailure(): AppThunk {
  return dispatch => new Promise(resolve => resolve(dispatch(createAction(EXPIRED_SESSION_FAILURE))))
}
